import { trackLink } from '@99designs/common/utils/platform';

document.addEventListener('DOMContentLoaded', () => {
    const bannerCTA = document.querySelector('[data-branding-products-recommender]');

    if (bannerCTA) {
        trackLink(bannerCTA, 'Branding recommender onramp clicked');
    }
});
